/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Electrical_Engineering21Inputs */

const en_cv_extract_form_enum_electrical_engineering21 = /** @type {(inputs: Cv_Extract_Form_Enum_Electrical_Engineering21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Electrical Engineering`)
};

const de_cv_extract_form_enum_electrical_engineering21 = /** @type {(inputs: Cv_Extract_Form_Enum_Electrical_Engineering21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elektrotechnik`)
};

/**
* | output |
* | --- |
* | "Electrical Engineering" |
*
* @param {Cv_Extract_Form_Enum_Electrical_Engineering21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_electrical_engineering21 = /** @type {((inputs?: Cv_Extract_Form_Enum_Electrical_Engineering21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Electrical_Engineering21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_electrical_engineering21(inputs)
	return en_cv_extract_form_enum_electrical_engineering21(inputs)
});
export { cv_extract_form_enum_electrical_engineering21 as "cv_extract_form_enum_ELECTRICAL_ENGINEERING" }